import { render } from "./indexsixappointment.vue?vue&type=template&id=05ee9655"
import script from "./indexsixappointment.vue?vue&type=script&lang=js"
export * from "./indexsixappointment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__